<template>
    <form class="grid-x grid-margin-x" @submit.prevent="submit">
        <div class="cell small-6 medium-3 large-4">
            <div class="input-group">
                <div class="input-group-label show-for-large">
                    Arrival:
                </div>
                <input
                    type="date"
                    class="input-group-field"
                    ref="fromDate"
                    v-model="fromDate"
                >
            </div>
        </div>
        <div class="cell small-6 medium-3 large-4">
            <div class="input-group">
                <div class="input-group-label show-for-large">
                    Departure:
                </div>
                <input
                    type="date"
                    class="input-group-field"
                    ref="toDate"
                    v-model="toDate"
                >
            </div>
        </div>
        <div class="cell small-6 medium-3 large-2">
            <div class="input-group">
                <div class="input-group-label">
                    <i class="fas fa-user"></i>
                </div>
                <select v-model="howMany" class="margin-bottom-0">
                    <option v-for="occupant in occupants" :key="occupant" v-text="occupant"></option>
                </select>
            </div>
        </div>
        <div class="cell small-6 medium-3 large-2">
            <button
                type="submit"
                class="expanded button inline-button"
            >GO</button>
        </div>
    </form>
</template>
<script>
    import Pikaday from 'pikaday';
    import moment from 'moment';
    export default {
        name: 'BookingDates',
        props: {
            from: {
                type: String,
                default: moment().format('YYYY-MM-DD')
            },
            to: {
                type: String,
                default: moment().add(1, 'days').format('YYYY-MM-DD')
            },
            guests: {
                type: Number,
                default: 2
            },
            maxDays: {
                type: Number,
                default: 31
            }
        },
        data() {
            return {
                howMany: this.guests,
                fromDate: this.from,
                toDate: this.to,
                minFrom: new Date,
                minTo: new Date,
                occupants: [1, 2, 3, 4, 5, 6, 7, 8],
            }
        },
        computed: {
            hasPicker() {
                let input = document.createElement('input');
                input.setAttribute('type','date');

                let notADateValue = 'not-a-date';
                input.setAttribute('value', notADateValue);

                return (input.value !== notADateValue);
            }
        },
        mounted() {
            this.initialize();
        },
        methods: {
            initialize() {
                if (this.hasPicker) {
                    return;
                }

                const to = new Pikaday({
                    field: this.$refs.toDate,
                    onSelect: (date) => {
                        this.toDate = moment(date).format('YYYY-MM-DD');
                    },
                    minDate: this.minTo
                });

                const from = new Pikaday({
                    field: this.$refs.fromDate,
                    onSelect: (date) => {
                        let momentDate = moment(date);

                        this.fromDate = momentDate.format('YYYY-MM-DD');
                        to.setMinDate(moment(date).add(1, 'days').toDate());
                    },
                    minDate: this.minFrom
                });

                this.$once("hook:beforeDestroy", () => {
                    from.destroy();
                    to.destroy();
                });
            },
            submit() {
                if (!this.toDate || !this.fromDate || !this.howMany) {
                    this.displayError('Please select all options');
                    return;
                }
                if (this.toDate <= this.fromDate) {
                    this.displayError('Leaving date has to be later than the arrival');
                    return;
                }
                if (this.fromDate < moment().format('YYYY-MM-DD')) {
                    this.displayError('Start date needs to be in the future');
                    return;
                }
                if (moment(this.toDate).diff(this.fromDate, 'days') > this.maxDays) {
                    this.displayError('You can book a maximum of ' + this.maxDays + ' days');
                    return;
                }
                window.location.href = '/booking/'+this.fromDate+'/'+this.toDate+'/'+this.howMany;
            },
            displayError(message) {
                window.EventHandler.fire('top-warning', {
                    id: 'booking-warning',
                    message: message
                });
            }
        }
    }
</script>